

const moment = require("moment");
/**
 * 
 * @param {标题头} tHeader 
 * @param {字段} filterVal 
 * @param {数据} sourceData 
 */
export function exportExcel(tHeader, filterVal,filename, sourceData) {
  import("@/vendor/Export2Excel").then((excel) => {
    let _tHeader = tHeader;
    let _filterVal = filterVal;
    const list = sourceData;
    const data = formatJson(_filterVal, list);
    excel.export_json_to_excel({
      header: _tHeader,
      data,
      filename: filename,
      autoWidth: true,
      bookType: 'xlsx',
    });
    // this.downloadLoading = false;
  });
}


function formatJson(filterVal, jsonData) {
  return jsonData.map((v) =>
    filterVal.map((j) => {
      if (j === "timestamp") {
        // return parseTime(v[j]);
        return v[j];
      } else {
        return v[j];
      }
    })
  );
}


/**
 * 导出老干部信息
 * @param {数据列表} list 
 */
export function exportCadresInfo(list) {

  const tHeader = [
     "姓名", "性别", "出生日期", "民族", "籍贯",
    "政治面貌", "入党时间", "证件", "证件号码",
    "参加革命工作时间", "参加革命时期", "原工作单位", "离休时职务",
    "离休时间", "校正后待遇", "医疗待遇", "原单位", 
    "归属","街道","类别", "是否健在", "已故时间",
    "所在基层党组织", "手机号", "座机号", "居住地址", "助餐情况",
    "长护险", "服务公司名称", "近期健康状况", "是否孤老", "居住情况",
    "子女情况", "配偶情况","配偶身体情况","居家保姆", "钟点工",
  ];

  const filterVal = [
     "name", "sex", "birthday", "nationname", "natives",
    "political", "partydate", "papers", "papersnum",
    "workdate", "workperiod", "workunit", "duty",
    "petireddate", "treatment", "medical", "organization",
    "belonging", "street","category", "alive", "deathdate",
    "partgroup", "mobile", "telephone", "address", "buffet",
    "insurance", "company", "health", "lonely", "live",
    "children", "spouse","spousehealth","homenanny", "hourlyworker",
  ];

  exportExcel(tHeader, filterVal,'老干部信息', list);
}


/**
 * 导出服务信息
 * @param {数据列表} list 
 */
export function exportRecordsInfo(list) {

  const tHeader = [
    "id", "服务项目", "服务日期", "服务对象","人次","金额", "慰问方式", "实物名称",
    "服务人员", "走访人员", "领导姓名", "职务职级", "陪同人员", "备注",
    "活动内容", "地点", "形式", "其他"
  ];

  const filterVal = [
    "id","itemname", "recorddate","cadresname", "times", "amount", "condolences", "physical",
    "person", "visitor", "leader", "jobrank", "escort", "remark",
    "activities", "location", "formal", "other"
  ];

  exportExcel(tHeader, filterVal,'服务信息', list);
}






